// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getInstanceInternalForms as listInstancesFormsAPI,
    getInstanceInternalForm as getInstanceFormAPI,
    addInstanceInternalForm as addInstanceFormAPI,
    updateInstanceInternalForm as updateInstanceFormAPI,
    deleteInstanceInternalForm as deleteInstanceFormAPI,
} from '../../helpers/';

import { instancesInternalFormsApiResponseError, instancesInternalFormsApiResponseSuccess } from './actions';
import { InstancesInternalFormsActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getInstanceForm({ payload: { id } }) {
    try {
        const response = yield call(getInstanceFormAPI, id );
        const instanceFormItem = response.data.data;
        yield put(instancesInternalFormsApiResponseSuccess(InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM, instanceFormItem));
    } catch (error) {
        yield put(instancesInternalFormsApiResponseError(InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM, error));
    }
}

function* addInstanceForm({payload:instanceForm}){
    try{
        const response = yield call(addInstanceFormAPI,{...instanceForm})
        const instanceFormItem = response.data
        yield put(instancesInternalFormsApiResponseSuccess(InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM,instanceFormItem))
    } catch(error){
        yield put(instancesInternalFormsApiResponseError(InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM,error))
    }
}

function* updateInstanceForm({payload:instanceForm}){
    try{
        const response = yield call(updateInstanceFormAPI,{...instanceForm})
        const instanceFormItem = response.data.data
        yield put(instancesInternalFormsApiResponseSuccess(InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM,instanceFormItem))
    }catch(error){
        yield put(instancesInternalFormsApiResponseError(InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM,error))
    }
}
function* deleteInstanceForm({payload:{id}}){
    try{
        const response = yield call(deleteInstanceFormAPI,id)
        const instanceFormItem = response.data.id
        yield put(instancesInternalFormsApiResponseSuccess(InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM,instanceFormItem))
    }catch(error){
        yield put(instancesInternalFormsApiResponseError(InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM,error))
    }
}

/**
 * List contactos
 */
function* listInstancesForms({payload:params}) {
    try {
        const response = yield call(listInstancesFormsAPI, { ...params });
        const listaInstancesForms = response.data.data;
        yield put(instancesInternalFormsApiResponseSuccess(InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS, listaInstancesForms));
    } catch (error) {
        yield put(instancesInternalFormsApiResponseError(InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS, error));
    }
}


export function* watchGetInstanceForm(): any {
    yield takeEvery(InstancesInternalFormsActionTypes.GET_INSTANCE_INTERNAL_FORM, getInstanceForm);
}

export function* watchListInstancesForms(): any {
    yield takeEvery(InstancesInternalFormsActionTypes.LIST_INSTANCES_INTERNAL_FORMS, listInstancesForms);
}

export function* watchAddInstanceForm():any{
    yield takeEvery(InstancesInternalFormsActionTypes.ADD_INSTANCE_INTERNAL_FORM,addInstanceForm)
}
export function* watchUpdateInstanceForm():any{
    yield takeEvery(InstancesInternalFormsActionTypes.UPDATE_INSTANCE_INTERNAL_FORM,updateInstanceForm)
}
export function* watchDeleteInstanceForm():any{
    yield takeEvery(InstancesInternalFormsActionTypes.DELETE_INSTANCE_INTERNAL_FORM,deleteInstanceForm)
}


function* instancesInternalFormsSaga(): any {
    yield all([
        fork(watchGetInstanceForm),
        fork(watchListInstancesForms),
        fork(watchAddInstanceForm),
        fork(watchUpdateInstanceForm),
        fork(watchDeleteInstanceForm),
    ]);
}

export default instancesInternalFormsSaga;
